import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Inspection } from '../../shared/models/index';
import { PluginComponent } from '../plugin.component';
import { BasePlugin } from '../base-plugin.component';
import { MachineFamillyService } from '../../shared/services';

@Component({
    templateUrl: './optimisationmachineselector.component.html',
    standalone: false
})
export class OptimisationMachineSelectorPluginComponent extends BasePlugin implements OnInit {
  public plugin: any;
  public inspection: Inspection;
  public machine: any[];

  constructor(private cdRef: ChangeDetectorRef, private machineFamillyService: MachineFamillyService) {
    super();
  }

  ngOnInit() {}

  config(
    plugin: any,
    inspection: Inspection,
    messages: Array<string>,
    showBreadcrumbs: boolean,
    showValidations: boolean,
    showContent: boolean
  ): void {
    super.config(plugin, inspection, messages, showBreadcrumbs, showValidations, showContent);
    this.machine =
      this.inspection.data != null && this.inspection.data.machine != null ? this.inspection.data.machine : null;
    if (this.machine && !(this.machine instanceof Array)) {
      this.machine = [this.machine];
    }
    this.cdRef.detectChanges();
  }

  getEditRoute() {
    return [
      this.inspectionsRoute,
      this.inspection.id,
      'plugins',
      this.plugin.id,
      'optimisationmachineselector',
      'edit'
    ];
  }
}

PluginComponent.plugins['optimisationmachineselector'] = OptimisationMachineSelectorPluginComponent;
